import { Table, Badge, NumberFormatter } from "@mantine/core";
import type { CptFrequencyRow } from "../../services/reports.service";

export interface CodeTableProps {
  rows: CptFrequencyRow[];
}

export function CodeTable({ rows }: CodeTableProps) {
  return (
    <Table striped highlightOnHover withTableBorder>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Code</Table.Th>
          <Table.Th>Stain Classification</Table.Th>
          <Table.Th>Description</Table.Th>
          <Table.Th>Count</Table.Th>
          <Table.Th>Unit Fee</Table.Th>
          <Table.Th>Total Fee</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {rows.map((row) => (
          <Table.Tr key={`${row.cptCodeId}:${row.cptCode}`}>
            <Table.Td>
              <Badge variant="outline">{row.cptCode}</Badge>
            </Table.Td>
            <Table.Td>{row.stainClassification || "—"}</Table.Td>
            <Table.Td>{row.description}</Table.Td>
            <Table.Td>{row.count}</Table.Td>
            <Table.Td>
              {row.unitFee != null ? (
                <NumberFormatter
                  value={row.unitFee}
                  prefix="$"
                  decimalScale={2}
                />
              ) : (
                "—"
              )}
            </Table.Td>
            <Table.Td>
              {row.totalFee != null ? (
                <NumberFormatter
                  value={row.totalFee}
                  prefix="$"
                  decimalScale={2}
                />
              ) : (
                "—"
              )}
            </Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}
